// generated by genversion
export var version = '3.5.4';
//# sourceMappingURL=version.js.map